const sidebarCategoryMeta = {
  "Daily Life & Dharma": { icon: "\uD83C\uDF05" },
  "Relationships & Family": { icon: "\uD83D\uDC68\u200D\uD83D\uDC69\u200D\uD83D\uDC67\u200D\uD83D\uDC66" },
  "Career & Duty": { icon: "\uD83D\uDCBC" },
  "Festivals & Rituals": { icon: "\uD83C\uDF8A" },
  "Philosophy & Spiritual Growth": { icon: "\uD83E\uDDD8" },
};

const baseQuestionLibrary = [
  {
    id: 1,
    question: "How to deal with anger according to Bhagavad Gita?",
    category: "Emotions",
    scripture: "Bhagavad Gita",
    tags: ["anger", "emotions", "self-control"],
    popularity: 95,
  },
  {
    id: 2,
    question: "What is the importance of daily puja?",
    category: "Daily Practice",
    scripture: "Various Scriptures",
    tags: ["worship", "rituals", "discipline"],
    popularity: 88,
  },
  {
    id: 3,
    question: "How to balance work and spiritual practice?",
    category: "Modern Life",
    scripture: "Bhagavad Gita",
    tags: ["work-life", "balance", "karma-yoga"],
    popularity: 92,
  },
  {
    id: 4,
    question: "Is anger always wrong according to Hindu scriptures?",
    category: "Emotions",
    scripture: "Bhagavad Gita",
    tags: ["anger", "righteousness", "emotions"],
    popularity: 87,
  },
  {
    id: 5,
    question: "How to perform daily worship without a temple?",
    category: "Daily Practice",
    scripture: "Various Scriptures",
    tags: ["home-worship", "simplicity", "devotion"],
    popularity: 84,
  },
  {
    id: 6,
    question: "What is the concept of Dharma in workplace?",
    category: "Modern Life",
    scripture: "Bhagavad Gita",
    tags: ["dharma", "career", "ethics"],
    popularity: 90,
  },
  {
    id: 7,
    question: "How to cultivate patience in difficult relationships?",
    category: "Relationships",
    scripture: "Ramayana",
    tags: ["patience", "relationships", "forgiveness"],
    popularity: 89,
  },
  {
    id: 8,
    question: "What does Bhagavad Gita say about dealing with anxiety?",
    category: "Mental Health",
    scripture: "Bhagavad Gita",
    tags: ["anxiety", "peace", "mind-control"],
    popularity: 94,
  },
  {
    id: 9,
    question: "How to find purpose in life according to Upanishads?",
    category: "Purpose",
    scripture: "Upanishads",
    tags: ["purpose", "meaning", "self-realization"],
    popularity: 91,
  },
  {
    id: 10,
    question: "What is the spiritual way to handle financial stress?",
    category: "Modern Life",
    scripture: "Various Scriptures",
    tags: ["money", "stress", "detachment"],
    popularity: 86,
  },
  {
    id: 11,
    question: "How to practice mindfulness in daily activities?",
    category: "Mindfulness",
    scripture: "Bhagavad Gita",
    tags: ["mindfulness", "presence", "awareness"],
    popularity: 88,
  },
  {
    id: 12,
    question: "What is the Hindu perspective on dealing with grief?",
    category: "Emotions",
    scripture: "Various Scriptures",
    tags: ["grief", "loss", "acceptance"],
    popularity: 85,
  },
  {
    id: 13,
    question: "How to stay motivated on spiritual path during tough times?",
    category: "Spiritual Growth",
    scripture: "Bhagavad Gita",
    tags: ["motivation", "perseverance", "faith"],
    popularity: 89,
  },
  {
    id: 14,
    question: "What does Krishna say about dealing with failure?",
    category: "Modern Life",
    scripture: "Bhagavad Gita",
    tags: ["failure", "success", "detachment"],
    popularity: 87,
  },
  {
    id: 15,
    question: "How to develop self-discipline spiritually?",
    category: "Self-Improvement",
    scripture: "Various Scriptures",
    tags: ["discipline", "willpower", "tapas"],
    popularity: 90,
  },
  {
    id: 16,
    question: "What is the role of meditation in modern life?",
    category: "Meditation",
    scripture: "Upanishads",
    tags: ["meditation", "modern-life", "peace"],
    popularity: 93,
  },
  {
    id: 17,
    question: "How to handle criticism with grace and wisdom?",
    category: "Relationships",
    scripture: "Ramayana",
    tags: ["criticism", "ego", "humility"],
    popularity: 84,
  },
  {
    id: 18,
    question: "What is the spiritual approach to dealing with envy?",
    category: "Emotions",
    scripture: "Bhagavad Gita",
    tags: ["envy", "contentment", "comparison"],
    popularity: 86,
  },
  {
    id: 19,
    question: "How to find inner peace in chaotic environments?",
    category: "Peace",
    scripture: "Bhagavad Gita",
    tags: ["peace", "chaos", "inner-calm"],
    popularity: 95,
  },
  {
    id: 20,
    question: "What is the meaning of true happiness in Hinduism?",
    category: "Philosophy",
    scripture: "Upanishads",
    tags: ["happiness", "bliss", "ananda"],
    popularity: 92,
  },
  {
    id: 21,
    question: "How to practice forgiveness according to Hindu teachings?",
    category: "Relationships",
    scripture: "Mahabharata",
    tags: ["forgiveness", "letting-go", "compassion"],
    popularity: 88,
  },
  {
    id: 22,
    question: "What is the spiritual significance of fasting?",
    category: "Rituals",
    scripture: "Various Scriptures",
    tags: ["fasting", "purification", "self-control"],
    popularity: 82,
  },
  {
    id: 23,
    question: "How to deal with loneliness spiritually?",
    category: "Mental Health",
    scripture: "Upanishads",
    tags: ["loneliness", "connection", "self-love"],
    popularity: 89,
  },
  {
    id: 24,
    question: "What is the concept of Nishkama Karma?",
    category: "Philosophy",
    scripture: "Bhagavad Gita",
    tags: ["detachment", "action", "karma-yoga"],
    popularity: 91,
  },
  {
    id: 25,
    question: "How to handle peer pressure while following Dharma?",
    category: "Modern Life",
    scripture: "Bhagavad Gita",
    tags: ["peer-pressure", "values", "courage"],
    popularity: 85,
  },
  {
    id: 26,
    question: "What is the role of gratitude in spiritual growth?",
    category: "Spiritual Growth",
    scripture: "Various Scriptures",
    tags: ["gratitude", "appreciation", "mindset"],
    popularity: 87,
  },
  {
    id: 27,
    question: "How to overcome fear of death?",
    category: "Philosophy",
    scripture: "Bhagavad Gita",
    tags: ["death", "fear", "immortality"],
    popularity: 90,
  },
  {
    id: 28,
    question: "What is the spiritual way to set and achieve goals?",
    category: "Modern Life",
    scripture: "Bhagavad Gita",
    tags: ["goals", "success", "detachment"],
    popularity: 86,
  },
  {
    id: 29,
    question: "How to develop intuition through spiritual practice?",
    category: "Spiritual Growth",
    scripture: "Upanishads",
    tags: ["intuition", "inner-guidance", "awareness"],
    popularity: 84,
  },
  {
    id: 30,
    question: "What does Hinduism say about dealing with injustice?",
    category: "Ethics",
    scripture: "Mahabharata",
    tags: ["justice", "dharma", "right-action"],
    popularity: 88,
  },
  {
    id: 31,
    question: "How to maintain spiritual practice while traveling?",
    category: "Daily Practice",
    scripture: "Various Scriptures",
    tags: ["travel", "consistency", "adaptability"],
    popularity: 83,
  },
  {
    id: 32,
    question: "What is the importance of Satsang?",
    category: "Community",
    scripture: "Various Scriptures",
    tags: ["community", "company", "inspiration"],
    popularity: 82,
  },
  {
    id: 33,
    question: "How to deal with negative thoughts spiritually?",
    category: "Mental Health",
    scripture: "Bhagavad Gita",
    tags: ["negative-thoughts", "mind-control", "positivity"],
    popularity: 94,
  },
  {
    id: 34,
    question: "What is the concept of Maya in daily life?",
    category: "Philosophy",
    scripture: "Upanishads",
    tags: ["maya", "illusion", "reality"],
    popularity: 87,
  },
  {
    id: 35,
    question: "How to practice Ahimsa in modern world?",
    category: "Ethics",
    scripture: "Various Scriptures",
    tags: ["non-violence", "compassion", "ethics"],
    popularity: 86,
  },
  {
    id: 36,
    question: "What is the spiritual approach to parenting?",
    category: "Relationships",
    scripture: "Various Scriptures",
    tags: ["parenting", "family", "values"],
    popularity: 85,
  },
  {
    id: 37,
    question: "How to handle success without ego?",
    category: "Self-Improvement",
    scripture: "Bhagavad Gita",
    tags: ["success", "ego", "humility"],
    popularity: 84,
  },
  {
    id: 38,
    question: "What is the meaning of Om in daily practice?",
    category: "Meditation",
    scripture: "Upanishads",
    tags: ["om", "mantra", "vibration"],
    popularity: 89,
  },
  {
    id: 39,
    question: "How to develop compassion for difficult people?",
    category: "Relationships",
    scripture: "Ramayana",
    tags: ["compassion", "difficult-people", "understanding"],
    popularity: 87,
  },
  {
    id: 40,
    question: "What is the role of diet in spiritual practice?",
    category: "Daily Practice",
    scripture: "Various Scriptures",
    tags: ["diet", "sattvic", "purification"],
    popularity: 83,
  },
  {
    id: 41,
    question: "How to overcome procrastination spiritually?",
    category: "Self-Improvement",
    scripture: "Bhagavad Gita",
    tags: ["procrastination", "action", "discipline"],
    popularity: 86,
  },
  {
    id: 42,
    question: "What is the significance of pilgrimage?",
    category: "Rituals",
    scripture: "Various Scriptures",
    tags: ["pilgrimage", "journey", "transformation"],
    popularity: 81,
  },
  {
    id: 43,
    question: "How to practice contentment in competitive world?",
    category: "Modern Life",
    scripture: "Bhagavad Gita",
    tags: ["contentment", "competition", "santosha"],
    popularity: 88,
  },
  {
    id: 44,
    question: "What is the spiritual view on modern technology?",
    category: "Modern Life",
    scripture: "Various Scriptures",
    tags: ["technology", "balance", "mindfulness"],
    popularity: 85,
  },
  {
    id: 45,
    question: "How to develop faith during doubts?",
    category: "Spiritual Growth",
    scripture: "Bhagavad Gita",
    tags: ["faith", "doubts", "trust"],
    popularity: 89,
  },
  {
    id: 46,
    question: "What is the importance of self-reflection?",
    category: "Self-Improvement",
    scripture: "Upanishads",
    tags: ["self-reflection", "introspection", "growth"],
    popularity: 87,
  },
  {
    id: 47,
    question: "How to handle social media from spiritual perspective?",
    category: "Modern Life",
    scripture: "Various Scriptures",
    tags: ["social-media", "mindfulness", "detachment"],
    popularity: 90,
  },
  {
    id: 48,
    question: "What is the concept of Karma in relationships?",
    category: "Relationships",
    scripture: "Various Scriptures",
    tags: ["karma", "relationships", "cause-effect"],
    popularity: 88,
  },
  {
    id: 49,
    question: "How to practice silence in noisy world?",
    category: "Meditation",
    scripture: "Upanishads",
    tags: ["silence", "peace", "inner-quiet"],
    popularity: 86,
  },
  {
    id: 50,
    question: "What is the ultimate goal of human life according to Vedanta?",
    category: "Philosophy",
    scripture: "Upanishads",
    tags: ["purpose", "moksha", "liberation"],
    popularity: 93,
  },
];

export const getSidebarCategoryForQuestion = (question) => {
  if (
    ["Relationships", "Community"].includes(question.category)
  ) {
    return "Relationships & Family";
  }

  if (question.category === "Rituals") {
    return "Festivals & Rituals";
  }

  if (
    ["Spiritual Growth", "Philosophy", "Meditation", "Purpose", "Peace", "Self-Improvement"].includes(
      question.category
    )
  ) {
    return "Philosophy & Spiritual Growth";
  }

  if (question.category === "Ethics") {
    return "Career & Duty";
  }

  if (question.category === "Modern Life") {
    const normalizedQuestion = question.question.toLowerCase();
    const careerKeywords = [
      "work",
      "workplace",
      "career",
      "financial",
      "goal",
      "success",
      "failure",
      "professional",
      "competition",
    ];

    if (careerKeywords.some((keyword) => normalizedQuestion.includes(keyword))) {
      return "Career & Duty";
    }
  }

  return "Daily Life & Dharma";
};

export const QUESTION_LIBRARY = baseQuestionLibrary.map((question) => ({
  ...question,
  sidebarCategory: getSidebarCategoryForQuestion(question),
}));

export const QUESTION_LIBRARY_CATEGORIES = [
  {
    id: "all",
    name: "All Questions",
    icon: null,
    count: QUESTION_LIBRARY.length,
  },
  ...Object.entries(sidebarCategoryMeta).map(([name, meta]) => ({
    id: name,
    name,
    icon: meta.icon,
    count: QUESTION_LIBRARY.filter(
      (question) => question.sidebarCategory === name
    ).length,
  })),
];
